import { dayLabel } from '../lib/dates.js';
import { haptic } from '../lib/telegram.js';
import { FlameIcon } from './FlameIcon.js';

interface Props {
  date: string;
  today: string;
  streak: number;
  /** Возврат к сегодняшнему дню по нажатию на дату. */
  onToday: () => void;
  onSettings: () => void;
}

function Gear() {
  return (
    <svg
      className="gear"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="3.1" />
      <path d="M19.3 14.6a1.6 1.6 0 0 0 .3 1.8l.1.1a1.9 1.9 0 1 1-2.7 2.7l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5v.2a1.9 1.9 0 1 1-3.8 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a1.9 1.9 0 1 1-2.7-2.7l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H4a1.9 1.9 0 1 1 0-3.8h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a1.9 1.9 0 1 1 2.7-2.7l.1.1a1.6 1.6 0 0 0 1.8.3h.1a1.6 1.6 0 0 0 1-1.5V4a1.9 1.9 0 1 1 3.8 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a1.9 1.9 0 1 1 2.7 2.7l-.1.1a1.6 1.6 0 0 0-.3 1.8v.1a1.6 1.6 0 0 0 1.5 1h.2a1.9 1.9 0 1 1 0 3.8H20a1.6 1.6 0 0 0-1.5 1Z" />
    </svg>
  );
}

export function AppBar({ date, today, streak, onToday, onSettings }: Props) {
  const isToday = date === today;

  return (
    <header className="appbar">
      <img className="appbar-logo" src="/logo-short.svg" alt="Cora" />

      <button
        className="glass pill pill-date"
        onClick={() => {
          if (isToday) return;
          haptic();
          onToday();
        }}
        // Нажатие имеет смысл только как возврат к сегодня
        aria-disabled={isToday}
      >
        {dayLabel(date, today)}
      </button>

      <div className="glass pill pill-actions">
        <span
          className="streak"
          title={`Дней подряд с записями: ${streak}`}
          aria-label={`Серия: ${streak} дней подряд`}
        >
          <FlameIcon className="flame" />
          {streak}
        </span>
        <button
          className="gear-btn"
          onClick={() => {
            haptic();
            onSettings();
          }}
          aria-label="Настройки профиля"
        >
          <Gear />
        </button>
      </div>
    </header>
  );
}
